import { ISelectMultipleOptionStatus } from 'src/app/project/components/input/select-multiple/select-multiple.model';
import { EBasicField } from 'src/app/project/shared/enums/basic-fields-enums';
import { EPriority, TPriority } from '../../points/priorities';
import { TFilters } from '../site-filter.model';

export const defaultPriorities = [
  {
    value: EPriority.LOW,
    label: EPriority.LOW,
    color: 'Blue',
    selected: false,
    testId: 'priorityLowButton',
  },
  {
    value: EPriority.MEDIUM,
    label: EPriority.MEDIUM,
    color: 'yellow',
    selected: false,
    testId: 'priorityMediumButton',
  },
  {
    value: EPriority.HIGH,
    label: EPriority.HIGH,
    color: 'red',
    selected: false,
    testId: 'priorityHighButton',
  },
];

export const getSyncConfigs = (
  priorities: TPriority[],
  allStatus: ISelectMultipleOptionStatus[],
  userFilters: TFilters,
) => [
  {
    key: EBasicField.PRIORITY.toLowerCase(),
    items: priorities,
    type: 'toggle',
  },
  {
    key: EBasicField.STATUS.toLowerCase(),
    items: allStatus,
    type: 'toggle',
  },
  {
    key: EBasicField.CREATED_BY.toLowerCase(),
    target: 'createdBy',
    group: userFilters.createdBy,
    type: 'user',
  },
  {
    key: EBasicField.ASSIGNEES.toLowerCase(),
    target: 'assignees',
    group: userFilters.assignees,
    type: 'user',
  },
  {
    key: EBasicField.TAGS.toLowerCase(),
    target: 'tags',
    group: userFilters.tags,
    type: 'tags',
  },
  {
    key: EBasicField.EXCLUDED_TAGS.toLowerCase(),
    target: 'excludedTags',
    group: userFilters.excludedTags,
    type: 'tags',
  },
  {
    key: 'workspaceref.id',
    target: 'site',
    type: 'list',
  },
];
